/**
 * Line-shape rules for over/under Markets (GL-10, ADR-0004 amendment). A Pick is right or
 * wrong with no push semantics, so v1 only offers exactly half-point Lines.
 */
/** Exactly half-point: `line * 2` is an odd integer. Whole and quarter Lines fail. */
export function isHalfPointLine(line) {
    const doubled = line * 2;
    return Number.isInteger(doubled) && Math.abs(doubled % 2) === 1;
}
//# sourceMappingURL=line.js.map